<bricks-modal [closeable]="true" (closeDialog)="closeDialog()">
  <bricks-modal-header> Leider ist eine Problem aufgetreten </bricks-modal-header>
  <bricks-modal-body class="error-message-body">
    <div class="error-message-text">
      Bei der Verarbeitung Ihrer Anfrage ist ein unerwartetes Problem aufgetreten, sodass Ihre Angaben nicht übermittelt
      werden konnten. Bitte versuchen Sie es zunächst erneut.
    </div>
    <br />
    <div class="error-message-text">
      Sollte das Problem weiterhin bestehen, können Sie Ihre Anfrage alternativ manuell an uns senden:
    </div>
    <ul class="icon-list">
      <li class="list-item">
        <span class="number-circle">1</span>
        <span>
          <a
            href="/assets/docs/2025_EnBW_Stammdatentemplate_Direktvermarktung-Indikation_Wind_PV.xltx"
            target="_blank"
            class="download-link">
            Stammdatenblatt herunterladen
            <bricks-icon class="download-icon">bricks-download</bricks-icon>
          </a>
          und lokal speichern
        </span>
      </li>
      <li>
        <span class="number-circle">2</span>
        <span>Stammdatenblatt vollständig ausfüllen</span>
      </li>
      <li>
        <span class="number-circle">3</span>
        <span>
          Ausgefülltes Stammdatenblatt per E-Mail an: <br />
          <a href="mailto:{{ contactEmail() }}" target="_blank">
            <u>{{ contactEmail() }}</u>
          </a>
        </span>
      </li>
    </ul>

    <div class="error-message-text">
      Unser Sales-Team erstellt Ihnen anschließend schnellstmöglich ein Angebot und sendet es Ihnen per E-Mail zu.
    </div>
    <br />
    <div class="error-message-text">Vielen Dank für Ihr Verständnis!</div>
  </bricks-modal-body>
  <bricks-modal-footer>
    <button class="bricks-button button-fn button-color" (click)="closeDialog()">
      <span class="button-text">Schließen</span>
    </button>
  </bricks-modal-footer>
</bricks-modal>
